import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import * as d3 from 'd3';

import ReactTooltip from "react-tooltip"

const styles = theme => ({
  root: {
    position: 'relative',
    height: '0px',
  },
  container: {
    //backgroundColor: 'blue',
    position: 'absolute',
    top: '150px',
    maxWidth: '150px',
    height: '170px',
    width: '150px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  northImageContainer: {
    //border: '1px solid black',
    //left: '0px',
    //top: '0px',
    //backgroundColor: 'red',
    width: '45px',
    //height: '45px',
    height: '40px',
  },
  northImage: {
    display: 'block',
    margin: '0 auto ',
    //border:'1px solid red',
    backgroundImage: 'url("/images/north_arrow_offshore_cropped.svg")',
    backgroundSize: 'contain!important',
    backgroundRepeat: 'no-repeat!important',
    backgroundPosition: 'center center!important',
    width: '80%',
    height: '100%',
    /*
    [theme.breakpoints.down('xs')]: {
      maxWidth: '45px',
      height: '45px',
    },
    [theme.breakpoints.up('sm')]: {
      maxWidth: '70px',
      height: '70px',
    },
    [theme.breakpoints.up('md')]: {
      maxWidth: '80px',
      height: '80px',
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: '100px',
      maxHeight: '60px',
      marginTop: '10px',
    },
    */
  },
  textContainer: {
    /*
    position: 'absolute',
    [theme.breakpoints.down('xs')]: {
      left: '0px',
      top: '60px',
      //width:'45px',
      //height:'45px',
    },
    [theme.breakpoints.up('sm')]: {
      left: '0px',
      top: '110px',
      //width:'40px',
      //height:'40px',
    },
    [theme.breakpoints.up('md')]: {
      top: '130px',
      //width:'80px',
      //height:'80px',
    },
    [theme.breakpoints.up('lg')]: {
      top: '125px',
      //width:'160px',
      //height:'120px',
    },
    */
  },
  offshoreImageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '70px',
    minHeight: '70px',
    height: '70px',
    clipPath: 'circle(30px at 50% 50%)',
    /*
    position: 'absolute',
    border: '1px solid black',
    [theme.breakpoints.down('xs')]: {
      left: '0px',
      top: '70px',
      width: '45px',
      height: '45px',
    },
    [theme.breakpoints.up('sm')]: {
      left: '0px',
      top: '130px',
      width: '100px',
      height: '70px',
    },
    [theme.breakpoints.up('md')]: {
      top: '145px',
      width: '120px',
      height: '80px',
    },
    [theme.breakpoints.up('lg')]: {
      top: '250px',
      //width:'180px',
      //height:'140px',
      //clipPath: 'ellipse(80px 60px at 50% 45%)',
      width: '140px',
      height: '80px',
    },
    */
  },
  offshoreImage: {
    //border:'1px solid red',
    backgroundImage: 'url("/images/spw_energy_selector/wind_offshore_white.svg")',
    backgroundSize: 'contain!important',
    backgroundRepeat: 'no-repeat!important',
    backgroundPosition: 'center center!important',
    width: '35px',
    height: '35px',
    paddingTop: '10px',
    /*
    [theme.breakpoints.down('xs')]: {
      maxWidth: '45px',
      height: '45px',
    },
    [theme.breakpoints.up('sm')]: {
      maxWidth: '70px',
      height: '70px',
    },
    [theme.breakpoints.up('md')]: {
      maxWidth: '80px',
      height: '80px',
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: '100px',
      maxHeight: '60px',
      marginTop: '10px',
    },
    */
  },
  /*
  centered: {
    position: 'relative',
    top: '50%',
    transform: 'translateY(-50%)',
    marginLeft: '-5px',
    fontFamily: 'Nunito Sans !important',
    fontWeight: '600',
  },
  */
  toolTip: {
    opacity: '1!important',
    fontFamily: 'Nunito Sans Regular!important',
    fontSize: '10pt!important',
    //minWidth:'280px',
    color: 'black!important',
  },
  leftTableColumn: {
    //width: '75%',
    width: '230px',
    textAlign: 'left',
    fontSize: '10pt!important',
  },
  rightTableColumn: {
    //width: '25%',
    textAlign: 'right',
    fontFamily: 'Nunito Sans Bold!important',
    fontSize: '10pt!important',
  },
  tableHeader: {
    fontFamily: 'Nunito Sans Bold!important',
  },
});

function MapOffshoreIcon(props) {
  const { classes } = props;

  //const unit= 'Wh';
  //const format = d3.format('~s');

  const [currentState, setCurrentState] = useState({
    valueScale: d3.scaleLinear().clamp(true),
    colorScale: d3.scaleLinear().interpolate(d3.interpolateRgb),
    unitHour: 'Wh',
    unitMonth: 'Wh',
    componentUpdated: false,
    data: [],
    currentTech: {
      solar: true,
      wind: false,
      windOffshore: false,
    },
    currentFilter: 'energy',
    currentMode: 'realtime',
    hasForecast: false,
  });

  useEffect(() => {
    if (props.dataReady & props.data !== undefined && props.data.length > 0) {
      let stateUpdated = (
        JSON.stringify(props.currentTech) === JSON.stringify(currentState.currentTech)
        && props.currentFilter === currentState.currentFilter
        && props.currentMode === currentState.currentMode
        && props.currentDateTime === currentState.currentDateTime
        && props.data === currentState.data
      )
      if (!stateUpdated || !currentState.componentUpdated)
        updateIconData()
    }
  });

  //if (!props.show)
  //  return <div/>

  function updateIconData() {
    let valueScale = currentState.valueScale
    let colorScale = currentState.colorScale

    let unitHour = currentState.unitHour
    let unitMonth = currentState.unitMonth

    // map js color function
    valueScale.range([0, props.colorArray.length - 1])
    colorScale.range(props.colorArray.map(function (hex) { return d3.color(hex) }));

    //const maxValue=d3.max(props.nisSums, function (t) { return t.values })

    colorScale.domain([...Array(props.colorArray.length).keys()].map(valueScale.invert))
    valueScale.domain([0, props.maxValue]).nice()
    colorScale.domain([...Array(colorScale.domain().length).keys()].map(valueScale.invert))

    let inw
    switch (props.lang) {
      case "de":
        inw = "einw"
        break;
      case "en":
        inw = "inh"
        break;
      case "fr":
      default:
        inw = "hab"
    }

    switch (props.currentFilter) {
      case 'inhabitants':
        unitHour = 'Wh/' + inw;
        unitMonth = 'kWh/' + inw;
        break;
      case 'surface':
        unitHour = 'MWh/km²';
        unitMonth = 'GWh/km²';
        break;
      default:
      case 'energy':
        unitHour = 'MWh';
        unitMonth = 'GWh';
    }

    let currentTech = props.currentTech
    let currentFilter = props.currentFilter
    let currentMode = props.currentMode
    let currentDateTime = props.currentDateTime
    let currentData = props.data.filter(function (v) {
      return (v.datetime.getTime() === new Date(currentDateTime).getTime())
    })[0].values
    //let backgroundColor=currentState.colorScale(currentData);

    const actualDate = new Date();
    const currentSelectedDate = new Date(props.currentDateTime)
    const hasForecast = (currentSelectedDate.toDateString() === actualDate.toDateString() || currentSelectedDate.getTime() > actualDate.getTime())

    setCurrentState({
      colorScale: colorScale,
      valueScale: valueScale,
      componentUpdated: true,
      currentTech: currentTech,
      currentFilter: currentFilter,
      currentMode: currentMode,
      data: props.data,
      unitHour: unitHour,
      unitMonth: unitMonth,
      currentDateTime: props.currentDateTime,
      hasForecast: hasForecast,
    });
  }

  let currentData
  if (props.dataReady && currentState.data !== undefined && currentState.data.length > 0) {
    let currentDateTime = currentState.currentDateTime
    currentData = currentState.data.filter(function (v) {
      return (v.datetime.getTime() === new Date(currentDateTime).getTime())
    })[0].values
  }

  const currentMode = props.currentMode

  const currentYear = parseInt(d3.timeFormat('%Y')(new Date()))
  const energyUsePerFamily = (props.currentMode === 'realtime' ? (3500 / 365.25) : (props.yearSelected === currentYear ? (props.data !== undefined && props.data.length > 0 ? (3500 * props.data.length / 12) : 0) : 3500))

  const hasForecast = currentState.hasForecast
  const unitHour = currentState.unitHour
  const unitMonth = currentState.unitMonth

  const lang = props.lang
  let municipalityLabel

  let inhabitantAbbreviation
  let renewableEnergy

  let perHour
  let perDay
  let predictedForDay


  let perMonth
  let perYear
  let predictedForYear

  let productionLastHourLabel
  let dayProductionLabel
  let expectedDayProductionLabel

  let productionLastMonthLabel
  let monthProductionLabel
  let expectedMonthProductionLabel

  let familiesProvidedLabel
  let powerLabel
  let co2AvoidedLabel


  switch (lang) {
    case "de":
      municipalityLabel = "Gemeente"

      inhabitantAbbreviation = "Einw"
      renewableEnergy = 'Ernuerbare Produktion'

      perHour = 'pro Stunde'
      perDay = 'für den Tag'
      predictedForDay = 'für den Tag geplant'

      //productionLastHourLabel = "Productie afgelopen uur (in "
      //dayProductionLabel = "Productie volledige dag (in "
      //expectedDayProductionLabel = "Verwachte productie volledige dag (in"

      perMonth = 'pro Monat'
      perYear = 'für das Jahr'
      predictedForYear = 'für das Jahr geplant'

      productionLastMonthLabel = "Productie afgelopen maand (in "
      monthProductionLabel = "Productie volledige dag (in "
      expectedMonthProductionLabel = "Verwachte productie volledige dag (in"

      familiesProvidedLabel = "Anzahl der belieferten Haushalte (Tausende)"
      powerLabel = "Installierte Leistung (MW)"
      co2AvoidedLabel = "CO\u2082 vermieden (Tonne)"
      break
    case "en":
      municipalityLabel = "Municipality"

      inhabitantAbbreviation = "inh"
      renewableEnergy = 'Production from renewables'

      perHour = 'per hour'
      perDay = 'for the day'
      predictedForDay = 'forecasted for the day'

      //productionLastHourLabel = "Production last hour (in "
      //dayProductionLabel = "Production whole day (in "
      //expectedDayProductionLabel = "Expected production whole day (in"

      perMonth = 'per month'
      perYear = 'for the year'
      predictedForYear = 'forecasted for the Year'

      productionLastMonthLabel = "Production last month (in "
      monthProductionLabel = "Production whole month (in "
      expectedMonthProductionLabel = "Expected production whole month (in"

      familiesProvidedLabel = "Number of provided households (thousands)"
      powerLabel = "Installed power (MW)"
      co2AvoidedLabel = "CO\u2082 avoided (ton)"
      break
    case "fr":
    default:
      municipalityLabel = "Commune"

      inhabitantAbbreviation = "hab"
      renewableEnergy = 'Production renouvelable'

      perHour = 'par heure'
      perDay = 'pour la journée'
      predictedForDay = 'prévue pour la journée'

      //productionLastHourLabel = "Production dernière heure (en "
      //dayProductionLabel = "Production journée complète (en "
      //expectedDayProductionLabel = "Production prévue toute la journée (en "

      perMonth = 'par mois'
      perYear = 'pour l\'année'
      predictedForYear = 'prévue pour l\'année'

      productionLastMonthLabel = "Production dernier mois (en "
      monthProductionLabel = "Production mois complet (en "
      expectedMonthProductionLabel = "Production prévue tout le mois (en "

      familiesProvidedLabel = "Nombre de foyers fournis (milliers)"
      powerLabel = "Puissance installée (MW)"
      co2AvoidedLabel = "CO\u2082 évité (ton)"
  }


  let reactToolTip
  const localeOption = (props.lang === "de" ? 'de-DE' : (props.lang === "en" ? 'en-GB' : 'fr-BE'))
  const co2AvoidedFactor = props.co2AvoidedFactor
  if (currentData !== undefined) {
    const municipalityName = "Offshore windturbines"
    const productionLastHour = currentData
    reactToolTip = (
      <ReactTooltip id="offshore" className={classes.toolTip + ' bgmediumgrey'}>
        <table style={{ minWidth: '300px' }}>
          <tbody>
            <tr>
              <td className={classes.leftTableColumn + ' ' + classes.tableHeader}>{municipalityLabel}</td>
              <td className={classes.rightTableColumn + ' ' + classes.tableHeader}>{municipalityName}</td>
            </tr>
            <tr>
              <td className={classes.leftTableColumn}>{renewableEnergy}</td>
              <td className={classes.rightTableColumn}></td>
            </tr>
            <tr>
              <td className={classes.leftTableColumn}>{
                currentMode === 'realtime' ?
                  (perHour + ' (' + unitHour + ')')
                  :
                  (perMonth + ' (' + unitMonth + ')')
              }
              </td>
              <td className={classes.rightTableColumn}>

                {
                  isNaN(productionLastHour) ? "0" : (
                    currentMode === 'realtime' ? (
                      props.currentFilter === 'inhabitants' ? (
                        productionLastHour * 10
                      ).toLocaleString(localeOption, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) // factor 1000 for going from kWh to Wh
                        :
                        Math.round(productionLastHour).toLocaleString(localeOption)
                    )
                      :
                      (
                        props.currentFilter === 'inhabitants' ?
                          (Math.floor(productionLastHour / 10) / 10).toLocaleString(localeOption) :
                          (Math.floor(productionLastHour / 100) / 10).toLocaleString(localeOption)
                      )
                  )
                }
              </td>
            </tr>
            <tr>
              <td className={classes.leftTableColumn}>
                {currentMode === 'realtime' ?
                  (hasForecast ?
                    (predictedForDay + ' (' + unitHour + ")")
                    : (perDay + ' (' + unitHour + ")")
                  )
                  :
                  (hasForecast ?
                    (predictedForYear + ' (' + unitMonth + ")")
                    : (perYear + ' (' + unitMonth + ")")
                  )
                }
              </td>
              <td className={classes.rightTableColumn}>
                {isNaN(props.dayProduction) ?
                  "0" :
                  (currentMode === 'realtime' ?
                    (props.currentFilter === 'inhabitants' ?
                      (props.dayProduction * 10).toLocaleString(localeOption, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) // factor 1000 for going from kWh to Wh
                      : Math.round(props.dayProduction).toLocaleString(localeOption)
                    )
                    :
                    (props.currentFilter === 'inhabitants' ?
                      (Math.floor(props.dayProduction / 10) / 10).toLocaleString(localeOption) :
                      (Math.floor(props.dayProduction / 100) / 10).toLocaleString(localeOption)
                    )
                  )
                }

              </td>
            </tr>
            {
              /*
              <tr>
                <td className={classes.leftTableColumn}>{
                  currentMode === 'realtime' ?
                    (productionLastHourLabel + unitHour + ')')
                    :
                    (productionLastMonthLabel + unitMonth + ')')
                }
                </td>
                <td className={classes.rightTableColumn}><b>{
                  isNaN(productionLastHour) ? "0" :
                    (currentMode === 'realtime' ?
                      (props.currentFilter === 'inhabitants' ?
                        (productionLastHour * 10).toLocaleString(localeOption, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) // factor 1000 for going from kWh to Wh
                        : Math.round(productionLastHour).toLocaleString(localeOption)
                      ) : (props.currentFilter === 'inhabitants' ?
                        (Math.floor(productionLastHour / 10) / 10).toLocaleString(localeOption) :
                        (Math.floor(productionLastHour / 100) / 10).toLocaleString(localeOption)
                      )
                    )
                }
                </b></td>
              </tr>
              <tr>
                <td className={classes.leftTableColumn}>
                  {currentMode === 'realtime' ?
                    (hasForecast ?
                      (expectedDayProductionLabel + unitHour + ")")
                      : (dayProductionLabel + unitHour + ")")
                    )
                    :
                    (hasForecast ?
                      (expectedMonthProductionLabel + unitMonth + ")")
                      : (monthProductionLabel + unitMonth + ")")
                    )
                  }
                </td>
                <td className={classes.rightTableColumn}>
                  <b>
                    {isNaN(props.dayProduction) ?
                      "0" :
                      (currentMode === 'realtime' ?
                        (props.currentFilter === 'inhabitants' ?
                          (props.dayProduction * 10).toLocaleString(localeOption, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) // factor 1000 for going from kWh to Wh
                          : Math.round(props.dayProduction).toLocaleString(localeOption)
                        )
                        :
                        (props.currentFilter === 'inhabitants' ?
                          (Math.floor(props.dayProduction / 10) / 10).toLocaleString(localeOption) :
                          (Math.floor(props.dayProduction / 100) / 10).toLocaleString(localeOption)
                        )
                      )
                    }
                  </b>
                </td>
              </tr>
                  */
            }
            <tr>
              <td className={classes.leftTableColumn}>{familiesProvidedLabel}</td>
              <td className={classes.rightTableColumn}><b>{isNaN(props.dayProduction) ? "0" : Math.floor(props.dayProduction * 1000 / energyUsePerFamily).toLocaleString('nl-BE')}</b></td>
            </tr>
            <tr>
              <td className={classes.leftTableColumn}>{powerLabel}</td>
              <td className={classes.rightTableColumn}>
                <b>
                  {isNaN(props.capacity) ? "0" : (Math.round(10 * props.capacity) / 10).toLocaleString(localeOption)}
                </b>
              </td>
            </tr>
            <tr>
              <td className={classes.leftTableColumn}>{co2AvoidedLabel}</td>
              <td className={classes.rightTableColumn}><b>{
                isNaN(props.dayProduction) ?
                  "0" :
                  (currentMode === 'realtime' ?
                    (props.currentFilter === 'inhabitants' ?
                      (co2AvoidedFactor * props.dayProduction * 10 / 1000).toLocaleString(localeOption, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) // factor 1000 for going from kWh to Wh
                      : Math.round(co2AvoidedFactor * props.dayProduction / 1000).toLocaleString(localeOption)
                    )
                    :
                    (props.currentFilter === 'inhabitants' ?
                      (Math.floor(co2AvoidedFactor * props.dayProduction / 10 / 1000) / 10).toLocaleString(localeOption) :
                      (Math.floor(co2AvoidedFactor * props.dayProduction / 100) / 10 / 1000).toLocaleString(localeOption)
                    )
                  )
              }</b></td>
            </tr>
          </tbody>
        </table>
      </ReactTooltip>
    );
  }
  let backgroundColor = props.currentTech.windOffshore ? currentState.colorScale(currentData) : '#dbdbdb';

  let offshoreWindEnergy
  switch (props.lang) {
    case "de":
      offshoreWindEnergy = "Offshore-Wind in der Nordsee"
      break;
    case "en":
      offshoreWindEnergy = "Offshore wind in the North Sea"
      break;
    case "fr":
    default:
      offshoreWindEnergy = "Éolien offshore en mer du nord"
  }

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <div style={{fontSize:'14pt',fontFamily:'Nunito Sans Bold'}}>N</div>  
        <div className={classes.northImageContainer}>
          <div className={classes.northImage}></div>
        </div>
        <div className={classes.textContainer}>{offshoreWindEnergy}</div>
        <div className={classes.offshoreImageContainer}
          style={{ backgroundColor: backgroundColor }}
        >
          <div
            className={classes.offshoreImage}
            data-tip='offshore'
            data-for='offshore'
          >
          </div>
        </div>
        {reactToolTip}
      </div>
    </div>
  );
}

MapOffshoreIcon.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MapOffshoreIcon);